var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:(_setup.tooltipText),expression:"tooltipText"}],ref:"textBlock"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.textContent))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }